import { useEffect, useState } from "react";
import { ContactUsSnap } from "./ContactUsSnap";
import { ContactUsNormal } from "./ContactUsNormal";
import { isApplySnap } from "@/utils";

export function ComponentContactUs({ pageContent = {} }) {
	const [applySnap, setApplySnap] = useState(false);
	const [desktop, setDesktop] = useState(false);

	useEffect(() => {
		setApplySnap(isApplySnap());
		if (window?.innerWidth >= 1600) {
			setDesktop(true);
		}
		function orientationChanged() {
			const timeout = 120;
			return new window.Promise(function (resolve) {
				const go = (i, height0) => {
					window.innerHeight != height0 || i >= timeout
						? resolve()
						: window.requestAnimationFrame(() => go(i + 1, height0));
				};
				go(0, window.innerHeight);
			});
		}
		window.addEventListener("orientationchange", function () {
			orientationChanged().then(function () {
				// Profit
				setApplySnap(isApplySnap());
			});
		});
		return () => {
			window.removeEventListener("orientationchange", function () {
				orientationChanged().then(function () {
					// Profit
					setApplySnap(isApplySnap());
				});
			});
		};
	}, []);

	return (
		<>
			{applySnap ? (
				<ContactUsSnap pageContent={pageContent} desktop={desktop} />
			) : (
				<ContactUsNormal pageContent={pageContent} desktop={desktop} />
			)}
		</>
	);
}
